<template>
    <a :class="'btn btn-' + size + ' ' + margins +' ' + (w100 ? 'w-100' : '') + ' ' + colorClass" @click="openCalendly"
       target="_blank">
        <i :class="'fa-solid fa-calendar-days me-2'"></i> {{ button_text }}
    </a>
</template>

<script>

export default {
    components: {},

    props: {
        button_text: {default: 'Plan een rondleiding'},
        colorClass: {default: 'btn-dark'},
        size: {default: 'lg'},
        margins: {default: 'm-2 mb-3'},
        w100: {default: true},
        calendlyUrl: {default: 'https://calendly.com/private-gym/rondleiding'}
    },

    mixins: [],

    data: function () {
        return {
            //
        };
    },

    computed: {
        //
    },

    created() {
        //
    },

    mounted() {
        //
    },

    methods: {
        openCalendly() {
            Calendly.initPopupWidget({url: this.calendlyUrl});return false;
        }
    },

    watch: {
        //
    }
};
</script>
